import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';

import { ConstantsModule } from '../constants/constants.module';
import { DialogPage } from '../root_classes/dialog-page';
import { UserAddMinicompanyComponent } from './../user-add-minicompany/user-add-minicompany.component';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent extends DialogPage implements OnInit {

	// Form data.
	userEditForm = new FormGroup({
		nameControl: new FormControl(''),
		firstnameControl: new FormControl(''),
		roleControl: new FormControl('U', [Validators.required]),
		companyControl: new FormControl(''),
	});

	// All companies list.
	public companies: any[] = [];

	// Extra data.
	public userId: string = "";
	public username: string = "";
	public companyName: string = "";
	public buttonText: string = "Modifier";
	public enableAction: boolean = true;

	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal, modalInstance: NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);
	}

	ngOnInit(): void {
		// Loading list of companies.
		this.put("/api/company-list-names", {companyname: this.companyName},
			(response: any) => {
				if (response.DATA == "ERR") {
					switch (response.VALUE) {
						case "UNAUTHORIZED":
							this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
							break;
						case "DATABASE":
							this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
							break;
						default:
							this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE +"). Contactez votre administrateur.";
							break;
					}
				} else {
					this.companies = response.RES;
				}
			},
			(err: any) => {
				// Cannot load the data.
				this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
			}
		);

		// Loading user data.
		var newData = {
			"id": this.userId
		};
		this.put("/api/user-info-self", newData, 
			(response: any) => {
				if (response.DATA == "ERR") {
					switch (response.VALUE) {
						case "UNAUTHORIZED":
							this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
							break;
						case "DATABASE":
							this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
							break;
						case "NOT FOUND":
							this.alertLine.alertDangerMessage = "Impossible de trouver l'utilisateur à éditer. Merci de recommencer l'opération.";
							break;
						default:
							this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
							break;
					}
				} else {
					this.userEditForm.controls["nameControl"].setValue(response.RES.name);
					this.userEditForm.controls["firstnameControl"].setValue(response.RES.firstname);
					this.userEditForm.controls["roleControl"].setValue(response.RES.role);

					if (this.username == this.cookieService.get(this.constantsModule.cookieUser)) {
						this.userEditForm.controls["roleControl"].disable();
					}

					if (response.RES.company == null) {
						// No company assigned.
						this.userEditForm.controls["companyControl"].setValue("");
					} else {
						// A company is assigned.
						this.userEditForm.controls["companyControl"].setValue(response.RES.company);
					}
				}
			},
			(err: any) => {
				// Cannot load the data.
				this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
			}
		);
	}

  	public setModalOptions(data: any): void {
		this.userId = data["id"];
		this.username = data["username"];
		this.companyName = data["companyName"];
	}

	public doAddCompany(): void {
		this.runModalDialog(UserAddMinicompanyComponent,
			(result:any) => {
				// Nothing.
			},
			(reason:any) => {
				// Adding a new company.
				var companyFound = false;
				for (var idx in this.companies) {
					if (this.companies[idx]._id == "---"+reason) {
						companyFound = true;
						break;
					}
				}
				if (!companyFound) {
					// Adding a new company.
					this.companies.push({_id:"---"+reason, name:reason});

					// Sorting the new list.
					this.companies.sort((element1, element2) => {
						if (element1.name < element2.name) return -1;
						if (element1.name > element2.name) return 1;

						return 0;
					});

					// Selecting the new company.
					this.userEditForm.controls["companyControl"].setValue("---"+reason);
				}
			}
		);
	}

	public save(): void {
		// Disabling button.
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

		var newData = {
			"id": this.userId,
			"name": this.userEditForm.controls["nameControl"].value,
			"firstname": this.userEditForm.controls["firstnameControl"].value,
			"role": this.userEditForm.controls["roleControl"].value,
			"company": this.userEditForm.controls["companyControl"].value,
			"company_name": "",
			"company_active": undefined,
			"global_active": undefined,
		};

		this.put("/api/user-edit", newData,
			(response:any) => {
				if (response.DATA == "ERR") {
					this.modalInstance.close(response.VALUE);
				} else {
					// If a company has been choosen, the name is updated.
					if (response.COMPANY_ID != undefined) {
						for(var index in this.companies) {
							if (this.companies[index]._id == newData["company"]) {
								newData["company"] = response.COMPANY_ID;
								newData["company_name"] = this.companies[index].name;
								newData["company_active"] = response.COMPANY_ACTIVE;
								newData["global_active"] = response.GLOBAL_ACTIVE;
								break;
							}
						}
					} else {
						newData["company"] = null;
						newData["company_name"] = "-";
						newData["company_active"] = undefined;
						newData["global_active"] = response.GLOBAL_ACTIVE;
					}

					this.modalInstance.dismiss(newData);
				}
			},
			(err:any) => {
				this.modalInstance.close(err);
			}
		);
	}

}
